import React from 'react';
import { Star, ArrowRight } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
export function HeroSection() {
  const handleBuyClick = e => {
    // Track AddToCart event
    trackAddToCart();
  };
  return <section className="w-full py-16 px-4 md:px-8 lg:px-16 bg-gradient-to-r from-indigo-900 to-purple-900 text-white" data-id="element-178">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center" data-id="element-179">
        <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-180">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-181">
            Desbloquea Tu Frecuencia Vibratoria Y Transforma Tu Vida En Solo 30
            Días
          </h1>
          <h2 className="text-xl md:text-2xl mb-8 text-indigo-100" data-id="element-182">
            El único programa que combina frecuencias ancestrales prohibidas con
            técnicas modernas para elevar tu energía y manifestar la vida que
            mereces
          </h2>
          <div className="flex flex-col sm:flex-row items-center mb-8" data-id="element-183">
            <a href="#inscripcion" className="bg-yellow-500 hover:bg-yellow-400 text-indigo-900 font-bold py-4 px-8 rounded-lg text-lg mb-4 sm:mb-0 sm:mr-4 flex items-center justify-center transition-all transform hover:scale-105 w-full sm:w-auto" onClick={handleBuyClick} data-id="element-184">
              Comenzar Mi Transformación
              <ArrowRight className="ml-2" size={20} data-id="element-185" />
            </a>
            <div className="text-indigo-100 text-center sm:text-left" data-id="element-186">
              <span className="block" data-id="element-187">Plazas limitadas</span>
              <span className="font-bold" data-id="element-188">¡Inscripción cierra pronto!</span>
            </div>
          </div>
          <div className="flex items-center" data-id="element-189">
            <div className="flex" data-id="element-190">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} size={20} className="fill-yellow-400 text-yellow-400" data-id="element-191" />)}
            </div>
            <span className="ml-2 text-indigo-100" data-id="element-192">
              <strong data-id="element-193">4.9/5</strong> - Más de 1,200 personas transformadas
            </span>
          </div>
        </div>
        <div className="md:w-1/2 md:pl-10" data-id="element-194">
          <div className="relative" data-id="element-195">
            <img src="https://images.unsplash.com/photo-1499209974431-9dddcece7f88?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2000&q=80" alt="Transformación energética" className="rounded-lg shadow-2xl w-full" data-id="element-196" />
            <div className="absolute -bottom-4 -right-4 bg-white text-indigo-900 p-3 rounded-lg shadow-lg" data-id="element-197">
              <p className="font-bold" data-id="element-198">¡Bono Exclusivo!</p>
              <p className="text-sm" data-id="element-199">3 meditaciones guiadas</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}